import classes from './Footer.module.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <div className={classes.up}>
                    <div className={classes.copyrightText}>
                        <p>
                            Copyright © 2007-{currentYear} RateZip.com All
                            Rights Reserved.
                        </p>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                <a
                                    rel='noreferrer'
                                    href='http://www.ratezip.com/privacy-and-security/'
                                    target='_blank'
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    rel='noreferrer'
                                    href='https://www.ratezip.com/licenses-and-disclosures/'
                                    target='_blank'
                                >
                                    Licenses & Disclosures
                                </a>
                            </li>
                            <li>
                                <a
                                    rel='noreferrer'
                                    href='http://www.ratezip.com/contact-us/'
                                    target='_blank'
                                >
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={classes.down}>
                    <p>
                        Peklava LLC, is a Duly Licensed Mortgage Broker and a
                        Marketing Lead Generator, as required by law, in{' '}
                        <a
                            href='//www.ratezip.com/licenses-and-disclosures/'
                            target='_blank'
                            rel='noreferrer'
                        >
                            23 states
                        </a>
                        , with its main office located at 59 Grove Street, Unit
                        2J, New Canaan, CT 06840, Peklava LLC, DBA RateZip NMLS
                        ID 1592292.{' '}
                        <a
                            href='http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1592292'
                            target='_blank'
                            rel='noreferrer'
                        >
                            NMLS Consumer Access
                        </a>
                        . This site is directed at, and made available to,
                        persons in the continental U.S, and Hawaii only.{' '}
                        <a
                            href='https://www.links3.us/o-jpbp-g32-0854e572b59a3d6cae5e48ab0e4a6ed6'
                            target='_blank'
                            rel='noreferrer'
                        >
                            California Consumers: Do Not Sell My Personal
                            Information
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Footer;
